import { useState } from "react";
import { NavLink } from "react-router-dom";
import { PanelLeftClose } from "lucide-react";
import { NAV_GROUPS } from "./navConfig";
import { useAuth } from "../lib/auth-context";

export function Sidebar() {
  const [collapsed, setCollapsed] = useState(false);
  const { user } = useAuth();

  return (
    <aside className={`shrink-0 border-r border-slate-200 dark:border-white/10 bg-white dark:bg-surface-1 flex flex-col transition-all duration-200 ${collapsed ? "w-[72px]" : "w-64"}`}>
      <div className="h-16 flex items-center gap-2 px-4 border-b border-slate-200 dark:border-white/10">
        <div className="h-8 w-8 rounded-lg bg-sbd-yellow flex items-center justify-center font-black text-sbd-black text-sm shrink-0">SB</div>
        {!collapsed && (
          <div className="font-bold text-sm leading-tight">
            Global Supplier
            <br />
            <span className="font-normal text-slate-400 text-xs">Portal</span>
          </div>
        )}
      </div>
      <nav className="flex-1 overflow-y-auto py-3 px-2 space-y-4 text-sm">
        {NAV_GROUPS.map((group) => {
          const visibleItems = group.items.filter((item) => user?.categories.includes(item.key));
          if (!visibleItems.length) return null;
          return (
            <div key={group.label}>
              {!collapsed && <div className="px-2 text-[10px] font-bold uppercase tracking-wider text-slate-400 mb-1">{group.label}</div>}
              {visibleItems.map((item) => (
                <NavLink
                  key={item.key}
                  to={`/${item.key === "dashboard" ? "" : item.key}`}
                  className={({ isActive }) =>
                    `w-full flex items-center gap-2.5 px-2.5 py-2 rounded-lg font-medium ${
                      isActive
                        ? "bg-sbd-yellow/15 text-sbd-black dark:text-sbd-yellow font-semibold"
                        : "text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-white/5"
                    }`
                  }
                >
                  <item.icon className="w-4 h-4 shrink-0" />
                  {!collapsed && <span>{item.label}</span>}
                </NavLink>
              ))}
            </div>
          );
        })}
      </nav>
      <div className="p-3 border-t border-slate-200 dark:border-white/10">
        <button onClick={() => setCollapsed((v) => !v)} className="w-full flex items-center justify-center gap-1.5 text-xs text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 py-1.5">
          <PanelLeftClose className="w-3.5 h-3.5" /> {!collapsed && "Collapse"}
        </button>
      </div>
    </aside>
  );
}
